import React from 'react';
import './dashboard.css';

const Dashboard = () => {
  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <h1>Admin Dashboard</h1>
      </header>
      <div className="dashboard-content">
        <aside className="sidebar">
          <ul>
            <li>Overview</li>
            <li>Users</li>
            <li>Settings</li>
            <li>Reports</li>
          </ul>
        </aside>
        <main className="main-content">
          <h2>Welcome to the Dashboard</h2>
          <p>This is a template dashboard. You can add more features here.</p>
          {/* Placeholder for future content */}
          <div className="placeholder">
            <h3>Overview</h3>
            <p>Statistics and charts will go here.</p>
          </div>
          <div className="placeholder">
            <h3>Recent Activity</h3>
            <p>Logs and recent actions.</p>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Dashboard;